import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}

export default class CardAteliers extends React.Component  <HomeProps> {
  state = {
    name: ''
  }  
  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    this.handleUpdateName();
   
    
  }
 
  componentDidUpdate(prevProps, prevState) {
    if (prevState.name !== prevProps.usernickname.nickname) {
      this.handleUpdateName();
    }
  }
  handleUpdateName = () => {
    this.setState({ name: this.props.usernickname.nickname });
    const item=document.getElementById('id_name');
    item.value=this.props.usernickname.nickname;
  }
   render() {
    
    const {isnotlabo,userrole,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;

    return(
     <div>
     
     {userrole=="teacher"?<span style={{display:isnotlabo}}>
     <Card style={{width:260,margin:4}} interactive={true} elevation={Elevation.TWO}>
     <h3><a href="">Ateliers</a></h3>
     <p><b>Accéder aux ateliers</b></p><p> Bientôt à venir...</p>
     <p></p>
     </Card>
     </span>:<div></div>}
     
     </div>);
}
}
